var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82933 4.01477C5.30862 3.93175 5.77814 4.20566 5.94174 4.66376L9 13.2269V5.00009C9 4.44781 9.44772 4.00009 10 4.00009C10.5523 4.00009 11 4.44781 11 5.00009V19.0001C11 19.4865 10.65 19.9024 10.1707 19.9854C9.69138 20.0684 9.22186 19.7945 9.05826 19.3364L6 10.7733V19.0001C6 19.5524 5.55228 20.0001 5 20.0001C4.44772 20.0001 4 19.5524 4 19.0001V5.00009C4 4.51366 4.35003 4.09779 4.82933 4.01477ZM13.8293 4.01477C14.3086 3.93175 14.7781 4.20566 14.9417 4.66376L18 13.2269V5.00009C18 4.44781 18.4477 4.00009 19 4.00009C19.5523 4.00009 20 4.44781 20 5.00009V19.0001C20 19.4865 19.65 19.9024 19.1707 19.9854C18.6914 20.0684 18.2219 19.7945 18.0583 19.3364L15 10.7733V19.0001C15 19.5524 14.5523 20.0001 14 20.0001C13.4477 20.0001 13 19.5524 13 19.0001V5.00009C13 4.51366 13.35 4.09779 13.8293 4.01477Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.00009C3 4.44781 3.44772 4.00009 4 4.00009H20C20.5523 4.00009 21 4.44781 21 5.00009C21 5.55238 20.5523 6.00009 20 6.00009H4C3.44772 6.00009 3 5.55238 3 5.00009Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19.0001C3 18.4478 3.44772 18.0001 4 18.0001H20C20.5523 18.0001 21 18.4478 21 19.0001C21 19.5524 20.5523 20.0001 20 20.0001H4C3.44772 20.0001 3 19.5524 3 19.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFence);
export default __webpack_public_path__ + "static/media/fence.3b238e127bb9c3656218a1e1a29c3603.svg";
export { ForwardRef as ReactComponent };